class AiUsageDailyGroupedPoint {
    constructor(
        public date: string = "",
        public label: string = "",
        public requestCount: number = 0,
        public apiCallCount: number = 0,
        public webSearchCallCount: number = 0,
        public totalTokens: number = 0,
        public price: number = 0
    ) {
    }

    public static fromPOJO(data: any) {
        return new AiUsageDailyGroupedPoint(
            data?.date ?? "",
            data?.label ?? "",
            data?.requestCount ?? 0,
            data?.apiCallCount ?? 0,
            data?.webSearchCallCount ?? 0,
            data?.totalTokens ?? 0,
            Number(data?.price ?? 0)
        );
    }
}

export default AiUsageDailyGroupedPoint;
